import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Home from './Pages/Home/Home/Home';
import Blog from './Pages/Blog/Blog';

function App() {
  return (
    <div>

  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/blogs" element={<Blog/>} />
      {/* <Route path="invoices" element={} /> */}
    </Routes>
  </BrowserRouter>
     
    </div>
  );
}

export default App;
